import { FC } from "react";
import { Chip } from "@mui/material";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

interface FilterTreeChipProps {
  title: string;
}

export const FilterTreeChip: FC<FilterTreeChipProps> = ({ title }) => {
  return (
    <Chip
      size="small"
      label={
        <TypographyWithTooltip variant="inherit" title={title} maxWidth={150} />
      }
      variant="outlined"
    />
  );
};
